import React from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  ImageBackground,
  Platform
} from "react-native";
import { withApollo } from "@apollo/client/react/hoc";
import { useReactiveVar, useApolloClient } from "@apollo/client";
import { referralCode } from "root/cache";
import NavHeader from "screens/LoginRegistration/utils/NavHeader";
import SButton from "styled42/components/SButton";
import { Colors } from "styled42/config";
import config from "config";
import SText from "styled42/components/SText";
import S3Image from "screens/common/S3Image";
import { isValidOTP } from "screens/LoginRegistration/utils";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";
import {
  ReadOTPReceived,
  RemoveSmsListenerIfRegistered
} from "utils/autoOtpRead";
import { TEST_IDS, ACCESSIBILITY_LABEL } from "utils/testIds/index";
import { AuthContext } from "utils/authentication/Auth";
import ComponentHeader from "../utils/ComponentHeader";
import OTPResend from "./OTPResend";
import OtpInputs from "./OtpInputs";
import { sendOTP, onSubmitHandler } from "./utils";

function withMyHook(Component) {
  return function WrappedComponent(props) {
    const referrCode = useReactiveVar(referralCode);
    console.log("here in gethook data");
    return <Component {...props} referrCode={referrCode} />;
  }
}
class OTPComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      otpTextFromSMS: "",
      isSubmitEnabled: false,
      error: {}
    };
    this.otpInputsRef = React.createRef();
  }

  componentDidMount = async () => {
    const { client, state, referrCode } = this.props;
    const { isNewUser, variant } = state;


    console.log("getRefferalDatagetRefferalData", referrCode);
    ReadOTPReceived(this.onSMSReceived);
    // if (!isNewUser) {
    await sendOTP({
      client,
      state,
      onSMSReceived: this.onSMSReceived,
      setError: this.setError
    });
    // }
    pushClevertapEvent("Page Load", {
      Current_Page: "New loginRegistration",
      Page_Modal: "OTP Verification",
      Test_Case: variant
    });
  };

  componentWillUnmount() {
    RemoveSmsListenerIfRegistered();
  }

  signIn = (tokenObj) => {
    const { signIn } = this.context;
    if (Platform.OS === "android") {
      signIn(tokenObj);
    }
  };

  onSMSReceived = (otpText) => {
    const {
      state: { variant }
    } = this.props;
    pushClevertapEvent("OTP Submit", {
      Current_Page: "New loginRegistration",
      Page_Modal: "OTP Verification",
      Test_Case: variant,
      Type: "Auto-fetch"
    });
    this.setState({ otpTextFromSMS: otpText });
  };

  setError = (error) => {
    // const {state:{variant}} = this.props;
    // pushClevertapEvent("OTP Submit Response", {
    //   Current_Page: "New loginRegistration",
    //   Page_Modal: "OTP Verification",
    //   Test_Case: variant,
    //   Type: "Login",
    //   Error: error.otp
    // });
    // TODO:Remove static msg checking
    const errorMsg = {
      otp:
        error.otp === "Invalid OTP provided"
          ? VernacManager.translateString("new_onboarding_enter_valid_otp")
          : error.otp
    };
    this.setState({ error: errorMsg });
  };

  onPressOTPHandler = async () => {
    const { otp } = this.state;
    const { client, state, goNext, referrCode } = this.props;
    const newError = {};
    const { variant } = state;

    if (!otp || otp.length < 5 || !isValidOTP(otp)) {
      newError.otp = VernacManager.translateString(
        "new_onboarding_invalid_otp"
      );
      this.setState({ error: newError });
      return;
    }

    if (newError && Object.keys(newError).length === 0) {
      const { isNewUser, otpTextFromSMS } = state;

      if (!otpTextFromSMS) {
        pushClevertapEvent("OTP Submit", {
          Current_Page: "New loginRegistration",
          Page_Modal: "OTP Verification",
          Test_Case: variant,
          Type: "Manual"
        });
      } else {
        pushClevertapEvent("OTP Submit", {
          Current_Page: "New loginRegistration",
          Page_Modal: "OTP Verification",
          Test_Case: variant,
          Type: "Auto-fetch"
        });
      }

      onSubmitHandler({
        otp,
        client,
        state,
        goNext,
        isNewUser,
        setError: this.setError,
        authSignIn: this.signIn,
        referralCode: referrCode
      });
    }
  };

  onChangeOTPHandler = (code) => {
    this.setState(
      {
        otp: code,
        isSubmitEnabled: code.length === 5,
        error: {}
      },
      () => {
        if (code.length === 5) {
          this.onPressOTPHandler();
        }
      }
    );
  };

  maskChar = (str, index, mask = "**") => {
    if (!str || !index) return str;
    let value = str;
    value =
      value.substring(0, index) + mask + value.substring(index + mask.length);
    return value;
  };

  onResendOTPClick = () => {
    // clear the otp
    this.otpInputsRef?.current?.clear();
    this.setState({ error: {} });
  };

  render() {
    const { error, otpTextFromSMS, isSubmitEnabled } = this.state;
    const { state, client, goBack } = this.props;
    const maskedNo = this.maskChar(state.user.mobile, 6);
    return (
      <View style={styles.root}>
        <ImageBackground
          source={{
            uri: `${config.S3_URL}/RocketIntegration/onboarding/loginBg.${Platform.OS === "web" ? "svg" : "png"
              }`
          }}
          style={{ width: "100%", height: "100%" }}
        >
          <NavHeader
            testID={TEST_IDS.OTP_BACK_BUTTON}
            accessibilityLabel={ACCESSIBILITY_LABEL.OTP_BACK_BUTTON}
            onBack={goBack}
            containerStyle={{ backgroundColor: "transparent" }}
          />
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={styles.container}
          >
            <S3Image
              name="otpLock"
              path="RocketIntegration/onboarding"
              // imageUrl="/static/onboarding/otpLock.svg"
              style={styles.otpLock}
            />
            {/* <ComponentHeader title={`OTP sent to ${state.user.mobile}`} /> */}
            <SText
              containerStyle={{
                width: "100%",
                textAlign: "center",
                marginTop: 32
              }}
              size={20}
              color="primary"
              weight="bold"
            >
              {VernacManager.translateString("new_onboarding_enter_otp")}
            </SText>
            <SText containerStyle={styles.otpLabel}>
              {/* Enter OTP (One Time Password) */}
              {` ${VernacManager.translateStringWithValues(
                "new_onboarding_5digit_otp",
                [maskedNo]
              )} `}
            </SText>
            <OtpInputs
              ref={this.otpInputsRef}
              handleChange={this.onChangeOTPHandler}
              errorMessage={error.otp}
              numberOfInputs={5}
              otpTextFromSMS={otpTextFromSMS}
              containerStyles={{ backgroundColor: "transparent" }}
            />
            {/* {error && error.otp && <SText color="error">{error.otp}</SText>} */}
            <View style={styles.otpContainer}>
              <OTPResend
                client={client}
                state={state}
                onSMSReceived={this.onSMSReceived}
                setError={this.setError}
                onClick={this.onResendOTPClick}
              />
            </View>
          </ScrollView>
          {/* <View style={styles.submitContainer}>
            <SButton
              text="Continue"
              disabled={!isSubmitEnabled}
              containerStyle={styles.submitButton}
              onClick={this.onPressOTPHandler}
            />
          </View> */}
          {error && error.otp && (
            <View
              style={styles.otpErrorContainer}
              testID={TEST_IDS.OTP_ERROR_VIEW}
              accessibilityLabel={ACCESSIBILITY_LABEL.OTP_ERROR_VIEW}
            >
              <S3Image
                name="warningYellow"
                path="RocketIntegration"
                // imageUrl="/static/onboarding/warningYellow.svg"
                style={{ height: 16, width: 16 }}
              />
              <SText
                color="#FFFFFF"
                size={12}
                containerStyle={{ marginLeft: 8 }}
              >
                {error.otp}
              </SText>
            </View>
          )}
        </ImageBackground>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    height: "100%",
    backgroundColor: "transparent"
  },
  container: {
    paddingHorizontal: 16
  },
  otpLock: {
    alignSelf: "center",
    width: 95,
    height: 90
  },
  otpLabel: {
    marginTop: 8,
    alignSelf: "center"
  },
  otpContainer: {
    marginTop: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  submitContainer: {
    marginTop: "auto",
    padding: 16,
    justifyContent: "flex-end",
    backgroundColor: "#ffffff"
  },
  submitButton: {},
  otpErrorContainer: {
    width: "100%",
    height: 40,
    backgroundColor: Colors.Grey[9],
    flexDirection: "row",
    padding: 12
  }
});

OTPComponent.contextType = AuthContext;

export default withMyHook(withApollo(OTPComponent));
